
import { ChallengeData } from "@/models/Base/ChallengeData";
import { Game } from "@/models/Game";
import { Dialog_Questions } from "@/models/MapPois/Quest/QuestMapPoi";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ChallengeBox from "@/components/Base/ChallengeBox.vue";
import ActionBox from "@/components/Base/Actions/ActionBox.vue";
import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

import {
  ActionRefData,
  QuestMapPoi,
  Quest_CG_DialogSection,
} from "@/models/MapPois/Quest/QuestMapPoi";
import { cloneDeep, isEqual, toArray } from "lodash";
import { ActionList } from "@/models/MapPois/Quest/Actions";
import { DropDownItem } from "@/models/Base/GlobalData";
import { Quests } from "@/models/MapPois/Quest/Quests";
import DialogQuestions from "./DialogQuestions/DialogQuestions.vue";

@Component({
  components: { ChallengeBox, ActionBox, DialogQuestions },
})
class PoiDialog extends Vue {
  @Prop({ default: null }) readonly mapPoi!: QuestMapPoi;
  @Prop({ default: null }) readonly contentString!: string;
  @Prop({ default: null }) readonly contentId!: number;
  @Prop({ default: null }) readonly dialogName!: string;
  @Prop({ default: null }) readonly gameData!: Game;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  showSavePanel = false;
  cloneMapPoi = {} as QuestMapPoi;
  questionArray: Dialog_Questions[] = [];

  get getQuestionArray(): Dialog_Questions[] {
    return this.questionArray;
  }

  get getContentData(): Quest_CG_DialogSection | undefined {
    if (this.dialogName === "d1") {
      return this.mapPoi.contentGroups[this.contentString].d1;
    } else {
      return this.mapPoi.contentGroups[this.contentString].d2;
    }
  }
  get getContentDataActions(): ActionList | undefined {
    if (this.dialogName === "d1") {
      if (
        this.mapPoi.contentGroups[this.contentString].d1.actions !== undefined
      ) {
        return this.mapPoi.contentGroups[this.contentString].d1.actions;
      } else {
        return {} as ActionList;
      }
    } else {
      if (
        this.mapPoi.contentGroups[this.contentString].d2!.actions !== undefined
      ) {
        return this.mapPoi.contentGroups[this.contentString].d2!.actions;
      } else {
        return {} as ActionList;
      }
    }
  }

  get getChallengeData(): ChallengeData {
    const challengeData = {} as ChallengeData;
    try {
      challengeData.text = this.getContentData?.txt.en || "";
      challengeData.image = this.getContentData?.imgs || "";
      challengeData.video = { en: "" };
      if (this.getContentData?.audio === undefined) {
        challengeData.audio = { en: "" };
      } else {
        challengeData.audio = this.getContentData.audio;
      }
      return challengeData;
    } catch (error) {
      console.log(error);
      return challengeData;
    }
  }

  get getQuestItems(): DropDownItem[] {
    return this.$store.state.questStore.quest.map((x: Quests) => ({
      text: x.key + " - " + x.title.en,
      value: x.key,
    }));
  }

  onDataChange(challenge: ChallengeData): void {
    if (this.getContentData !== undefined) {
      this.getContentData.txt.en = challenge.text;
      this.getContentData.imgs = challenge.image;
      this.getContentData.audio = challenge.audio;
      this.onValueChanged();
    }
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/img/poi/"
    );
  }

  get getAudioPath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/audio/poi/"
    );
  }

  created(): void {
    this.cloneMapPoi = cloneDeep(this.mapPoi);
    this.questionArray = toArray(this.getContentData!.questions);
    this.$v.$touch();
  }

  onValueChanged(): void {
    //if (!this.$v.$anyError) {
    if (!isEqual(this.mapPoi, this.cloneMapPoi)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", this.mapPoi);
    //}
  }

  update(contentData: any): void {
    this.addActionRefActions(contentData);
    if (this.dialogName === "d1") {
      this.mapPoi.contentGroups[this.contentString].d1.actions =
        contentData.contentData;
    } else {
      this.mapPoi.contentGroups[this.contentString].d2!.actions =
        contentData.contentData;
    }
    this.onValueChanged();
  }

  deleteAction(contentData: any): void {
    if (this.dialogName === "d1") {
      this.mapPoi.contentGroups[this.contentString].d1.actions =
        contentData.contentData;
    } else {
      if (this.mapPoi.contentGroups[this.contentString].d2 !== undefined) {
        this.mapPoi.contentGroups[this.contentString].d2!.actions =
          contentData.contentData || undefined;
      }
    }
    this.deleteActionRefAction(contentData);
    var data = {
      mapPoi: this.mapPoi,
      game_uid: this.gameData.key,
    };
    this.$store.dispatch("mapPoiStore/updateMapPoiType", data);
  }

  addActionRefActions(contentData: any): void {
    if (this.mapPoi.actionGoalRef === undefined) {
      this.mapPoi.actionGoalRef = [];
    }
    this.deleteActionRefAction(contentData);
    if (contentData.objectName === "timerAction") {
      var data = {
        id: contentData.actionDetails.value,
        helperPath: this.getHelperPath(contentData.objectName),
        path: this.getRealPath(contentData.objectName),
      };
      this.mapPoi.actionGoalRef?.push(data);
    } else if (contentData.objectName === "customAction") {
      var customData = {
        id: contentData.actionDetails.json,
        helperPath: this.getHelperPath(contentData.objectName),
        path: this.getRealPath(contentData.objectName),
      };
      this.mapPoi.actionGoalRef?.push(customData);
    } else {
      var actionItems = Object.values(contentData.actionDetails.upd);
      actionItems.forEach((x: any) => {
        var data: ActionRefData = {
          id: x.id,
          helperPath: this.getHelperPath(contentData.objectName),
          path: this.getRealPath(contentData.objectName),
        };
        this.mapPoi.actionGoalRef?.push(data);
      });
    }
  }

  addActionRefActionsQuestions(contentData: any, questionId: string): void {
    if (this.mapPoi.actionGoalRef === undefined) {
      this.mapPoi.actionGoalRef = [];
    }
    this.deleteActionRefActionQuestions(questionId);
    if (contentData.objectName === "timerAction") {
      var data = {
        questionId: questionId,
        id: contentData.actionDetails.value,
        helperPath: this.getHelperPathQuestions(contentData.objectName),
        path: this.getRealPathQuestions(contentData.objectName),
      };
      this.mapPoi.actionGoalRef?.push(data);
    } else if (contentData.objectName === "customAction") {
      var customData = {
        uestionId: questionId,
        id: contentData.actionDetails.json,
        helperPath: this.getHelperPath(contentData.objectName),
        path: this.getRealPath(contentData.objectName),
      };
      this.mapPoi.actionGoalRef?.push(customData);
    } else {
      var actionItems = Object.values(contentData.actionDetails.upd);
      actionItems.forEach((x: any) => {
        var data: ActionRefData = {
          id: x.id,
          questionId: questionId,
          helperPath: this.getHelperPathQuestions(contentData.objectName),
          path: this.getRealPathQuestions(contentData.objectName),
        };
        this.mapPoi.actionGoalRef?.push(data);
      });
    }
  }

  deleteActionRefAction(contentData: any): void {
    var data = this.mapPoi.actionGoalRef?.filter(
      (x: any) => x.path === this.getRealPath(contentData.objectName)
    );
    data?.forEach((x) => {
      this.mapPoi.actionGoalRef?.splice(
        this.mapPoi.actionGoalRef?.indexOf(x),
        1
      );
    });
  }

  deleteActionRefActionQuestions(questionId: string): void {
    var data = this.mapPoi.actionGoalRef?.filter(
      (x: any) => x.questionId == questionId
    );
    data?.forEach((x) => {
      this.mapPoi.actionGoalRef?.splice(
        this.mapPoi.actionGoalRef?.indexOf(x),
        1
      );
    });
  }

  getHelperPath(objectName: string): string {
    return (
      this.mapPoi.title.en +
      "/" +
      "Content Group" +
      this.contentId +
      "/" +
      this.dialogName +
      "/" +
      objectName
    );
  }
  getHelperPathQuestions(objectName: string): string {
    return (
      this.mapPoi.title.en +
      "/" +
      "Content Group" +
      this.contentId +
      "/" +
      this.dialogName +
      "/Questions/" +
      objectName
    );
  }
  getRealPath(objectName: string): string {
    return (
      this.mapPoi.key +
      "/contentGroups/" +
      this.contentString +
      "/" +
      this.dialogName +
      "/actions/" +
      objectName
    );
  }
  getRealPathQuestions(objectName: string): string {
    return (
      this.mapPoi.key +
      "/contentGroups/" +
      this.contentString +
      "/" +
      this.dialogName +
      "questions/actions/" +
      objectName
    );
  }
  getDialogPath(): string {
    return (
      this.mapPoi.key +
      "/contentGroups/" +
      this.contentString +
      "/" +
      this.dialogName
    );
  }
  AddNewQuestion(): void {
    if (!this.isEditingLocked && this.getQuestionArray.length < 3) {
      this.$store
        .dispatch("mapPoiStore/getDialogQuestionKey", this.getDialogPath())
        .then((results) => {
          this.questionArray.push({
            a: { en: "" },
            q: { en: "" },
            id: results,
            cost: { id: "", value: 0 },
            actions: {},
          });
        });
    }
  }

  updateData(data: any): void {
    if (data.contentData !== null) {
      this.addActionRefActionsQuestions(data.contentData, data.questionData.id);
    }
    if (this.getContentData!.questions === undefined) {
      this.getContentData!.questions = {
        [data.questionData.id]: data.questionData,
      };
    } else {
      this.getContentData!.questions[data.questionData.id] = data.questionData;
    }
    this.onValueChanged();
  }

  deleteData(data: any) {
    if (data.contentData !== null) {
      this.deleteActionRefActionQuestions(data.questionData.id);
    }
    if (this.getContentData!.questions === undefined) {
      this.getContentData!.questions = {
        [data.id]: data,
      };
    } else {
      this.getContentData!.questions[data.id] = data;
    }
    var mapPoiData = {
      mapPoi: this.mapPoi,
      game_uid: this.gameData.key,
    };
    this.$store.dispatch("mapPoiStore/updateMapPoiType", mapPoiData);
  }

  deleteQuestion(data: string): void {
    if (data !== null) {
      this.deleteActionRefActionQuestions(data);
    }
    delete this.getContentData!.questions![data];
    this.questionArray.splice(
      this.questionArray.findIndex((x: any) => x.id === data)
    );
    var mapPoiData = {
      mapPoi: this.mapPoi,
      game_uid: this.gameData.key,
    };
    this.$store.dispatch("mapPoiStore/updateMapPoiType", mapPoiData);
  }

  @Watch("getContentData", { deep: true })
  dialogChange(value: any): void {
    this.questionArray = toArray(this.getContentData!.questions);
  }
}

export default PoiDialog;
